// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable default-param-last */
import { createSelector } from "reselect"

import set from "../../utils/set"
import type { Action } from "./actions"
import type { Banner } from "../../../../app/scripts/tools/banner.types"

export type BannersConfig = {
  length?: number
  banners: Banner[]
  showOnMobile: boolean
}

export type RemoteConfig = {
  bannersConfig: BannersConfig
}

// add modules restrictions for banner and chatModal in future
const DEFAULT_STATE: RemoteConfig = {
  bannersConfig: {
    banners: [],
    showOnMobile: false,
  },
}

const remoteConfigReducer = (
  state: RemoteConfig | null | undefined = DEFAULT_STATE,
  action: Action,
): RemoteConfig => {
  switch (action.type) {
    case "SET_BANNERS":
      return set("bannersConfig", action.payload, state)

    case "REMOVE_BANNER": {
      // @ts-expect-error: Flow to TS migration.
      const newArray = [...state.bannersConfig.banners]
      // FIXME: a method has been detected that possibly mutates the object, consider a more
      // functional approach (Ramda might help)

      newArray.splice(action.payload.index, 1)
      return set(["bannersConfig", "banners"], newArray, state)
    }

    default:
      // @ts-expect-error: Flow to TS migration.
      return state
  }
}

export default remoteConfigReducer

// Data selectors
// ===

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getRemoteConfig = (state: any) => state.remoteConfig

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const bannersConfigSelector: any = createSelector(
  getRemoteConfig,
  (remoteConfig) => remoteConfig.bannersConfig,
)
